import { createSlice } from '@reduxjs/toolkit';
import posApi from './posApi';

const dataSlice = createSlice({
    name: 'pos',
    initialState: {
        posList: [],
    },
    extraReducers: (builder) => {
        builder.addMatcher(
            posApi.endpoints.posList.matchFulfilled,
            (state, action) => {
                state.posList = action.payload; // Save the new data to the state
            }
        );
    },
});

export default dataSlice.reducer;
